import { IComponentOptions, IController, ISCEService, IWindowService } from 'angular';
import { PaymentService } from '../../../core/services/payment/payment.service';
import { IPaymentData, IPaymentReqData } from '../../../core/services/payment/payment.interfaces';
import { ToastrService } from '../../../core/services/toastr/toastr.service';
import { ORDER_ERROR, ORDER_SUCCESS, OTHER_ERROR } from '../../../states/payment-process/constants/message-types';
import isObject from 'lodash-es/isObject';
import './payment-iframe-modal.component.scss';

export class PaymentIframeModalController implements IController {
  static $inject = [
    '$window',
    '$sce',
    'PaymentService',
    'ToastrService'
  ];
  onClose: ( data: { result: boolean } ) => void;
  data: IPaymentReqData;
  paymentData: IPaymentData;
  isIframeVisible: boolean;
  iframeUrl: string;

  constructor( private $window: IWindowService,
               private $sce: ISCEService,
               private paymentService: PaymentService,
               private toastrService: ToastrService ) {
    this.listener = this.listener.bind(this);
  }

  $onInit() {
    this.paymentService.getPaymentData(this.data)
      .then(( data ) => {
        this.paymentData = data;
        const config = JSON.stringify(data);
        this.iframeUrl = this.$sce.trustAsResourceUrl(`/payment-process?config=${config}`);
        this.isIframeVisible = true;
      })
      .catch(( err ) => {
        this.closeModal(false);
        this.toastrService.warning(err.text || err.message || JSON.stringify(err));
      });
  }

  $onDestroy() {
    this.$window.removeEventListener('message', this.listener);
  }

  closeModal( result: any ) {
    this.onClose({ result });
  }

  onIframeLoaded() {
    this.$window.addEventListener('message', this.listener);
  }

  private listener( event ) {
    if ( event.origin !== this.$window.origin ) {
      return;
    }
    const message = event.data;
    if ( isObject(message) ) {
      if ( message.type === ORDER_SUCCESS ) {
        this.closeModal({ success: true, message });
        return;
      }
      if ( message.type === ORDER_ERROR ) {
        this.closeModal({ success: false, message });
        return;
      }
      if ( message.type === OTHER_ERROR ) {
        this.closeModal({ success: false, message });
      }
    }
  }
}

export const PaymentIframeModalComponent: IComponentOptions = {
  controller: PaymentIframeModalController,
  template: require('./payment-iframe-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/payment-iframe-modal/payment-iframe-modal.component.ts